<template>
    <div>
        <svg height="100" width="200">
            <circle cx="100" cy="100" r="50" fill="transparent" stroke="black" />
            <circle id="inner" cx="100" cy="100" r="50" fill="transparent" stroke-width="5" />
        </svg>
    </div>
</template>

<style>
#inner {
    stroke: #f00;
    fill: none;
    stroke-dasharray: 40, 200;
    stroke-dashoffset: 80;
    /* dashoffset min 80 through -40     */
}
</style>
<script>
export default {
    props: {
        radius: Number,
        progress: Number,
        stroke: Number,
        percent: Number,
        cx: Number,
        cy: Number
    },
    data() {
        const normalizedRadius = this.radius - this.stroke * 2;
        const circumference = normalizedRadius * 2 * Math.PI;

        return {
            normalizedRadius,
            circumference
        };
    },
    computed: {
        strokeDashoffset() {
            return this._circumference - this.percent / 100 * this._circumference;
        }
    },
}
</script>
